export default "__VITE_ASSET__BAxwI9i6__"